import { cloneElement } from 'react';

import { SFStockoutItemChip } from 'features/order/substitution-flow';

import { useSubstitutionFlowToppingHOC } from './hooks';

import makeClasses from './SubstitutionFlowToppingHOC.style';

import type { ReactElement, ReactNode } from 'react';
import type { CustomizationId, OrderId, ProductId } from 'shared/domain';

export function SubstitutionFlowToppingHOC(props: Props) {
  const { orderId, orderProductId, customizationId, children } = props;

  const {
    hasReplacement,
    stockoutItem,
    replacementItem,
    formatedPrice,
  } = useSubstitutionFlowToppingHOC({
    orderId,
    orderProductId,
    customizationId,
  });

  const _classes = makeClasses();

  const showStockoutToppingChip = !!stockoutItem;
  if (!showStockoutToppingChip) return <>{children}</>;
  return (
    <article
      className={_classes.article}
      aria-label='substitution-flow-topping-hoc'
      data-topping-id={customizationId}
      data-has-replacement={hasReplacement}
      data-order-product-id={stockoutItem.orderProductId}
    >
      {hasReplacement && (
        <section
          aria-label='replacement-topping'
          data-topping-id={replacementItem?.id}
        >
          <header className={_classes.toppingHeader}>
            <h2>
              <span>{`${replacementItem?.units}x `}</span>
              {replacementItem?.name}
              <SFStockoutItemChip mode='replacement' />
            </h2>
            <span>{formatedPrice}</span>
          </header>
        </section>
      )}

      <section
        aria-label='stockout-topping'
        className={_classes.stockoutSection}
        data-topping-id={customizationId}
        data-has-replacement={hasReplacement}
        data-product-id={stockoutItem.productId}
      >
        {cloneElement(children as ReactElement, { showStockoutToppingChip })}
      </section>
    </article>
  );
}

interface Props {
  orderId: OrderId;
  orderProductId: ProductId;
  customizationId: CustomizationId;
  children: ReactNode;
}
